import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-event-venue',
  templateUrl: './event-venue.component.html',
  styleUrls: ['./event-venue.component.scss']
})
export class EventVenueComponent implements OnInit, OnDestroy  {
  @ViewChild('field', {static: true}) field: ElementRef;
  @Input() formGroupEventData: UntypedFormGroup = null;

  public eventVenue: UntypedFormGroup = null;
  public addressControl: UntypedFormControl = null;

  constructor() { }

  ngOnInit(): void {
    this.eventVenue = this.formGroupEventData.get('eventVenue') as UntypedFormGroup;
    this.addressControl = this.eventVenue.get('address') as UntypedFormControl;
  }
  
  ngOnDestroy(): void {
  }
}
